<template>
	<div class="aside">
		<div id="qr">
			<div class="asideImg"><img src="../../../image/ser.png" /></div>
			<div class="serve">
				<div class="serve-phone">客服电话：{{sidebar.Phone}}</div>
				<div class="serve-cimg">
					<span>客服微信：</span>
					<div class="qr-img"><img :src="sidebar.WeChartImg" /></div>
				</div>
			</div>
		</div>
		<div class="asideImg" @click="goUp()"><img src="../../../image/sera.png" /></div>
	</div>
</template>
<script>
	export default {
		name: 'passport',
		data() {
			return {
				sidebar: {}
			};
		},
		mounted() {
			this.GetSidebar();
		},
		methods: {
			goUp() {
				const nowTop = document.body.scrollTop || document.documentElement.scrollTop; // 获取当前滚动条位置
				if (nowTop > 0) {
					window.requestAnimationFrame(this.goUp);
					// window.scrollTo(0, nowTop - nowTop / 5);
					document.body.scrollTo(0, 0);
				}
			},
			// 获取底图
			GetSidebar: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetSidebar',
					'GET', {},
					function(res) {
						console.log('获取底图');
						console.log(res);
						if (res.code === 0) {
							that.sidebar = res.data;
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>
<style lang="scss" scoped>
	.asideImg:first-child {
		margin-bottom: 30px;
	}

	.asideImg img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.asideImg {
		width: 100%;
		height: 74px;
		cursor: pointer;
		position: relative;
	}

	.aside {
		width: 70px;
		height: auto;
		position: fixed;
		right: 20px;
		top: 60%;
		margin-top: 0;
		margin-right: 0;
		z-index: 10;
	}

	#qr {
		position: relative;
	}

	#qr:hover .serve {
		display: block;
	}

	.serve {
		width: 250px;
		height: auto;
		background-color: #fff;
		padding: 15px;
		position: absolute;
		margin-right: 100px;
		right: 0;
		margin-top: -100px;
		display: none;
	}

	.serve-phone {
		width: 100%;
		font-size: 15px;
		color: #333;
		margin-bottom: 10px;
	}

	.serve-cimg {
		display: flex;
		align-items: center;
	}

	.serve-cimg span {
		font-size: 15px;
		color: #333;
	}

	.qr-img {
		width: 130px;
		height: 130px;
	}

	.qr-img img {
		width: 100%;
		height: 100%;
		display: block;
	}
</style>
